var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPinned(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "a",
    xmlns: "http://www.w3.org/2000/svg",
    width: 21,
    height: 40,
    viewBox: "0 0 21 40",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M29.87726-7.91357c-5.10059,0-9.25,4.14941-9.25,9.25V6.72522h18.5V1.33643c0-5.10059-4.14941-9.25-9.25-9.25Z",
    fill: "none"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "b",
    d: "M17.67059,17.60303l-14.39675,.00183C1.50734,17.56376,.04198,18.96248,.00088,20.72898s1.35762,3.23186,3.12412,3.27296c.04928,.00114,.09857,.00115,.14785,.00002l14.39695,.00151c1.76673-.02998,3.17464-1.48651,3.14465-3.25324-.02925-1.72359-1.4188-3.11413-3.14237-3.14461l-.00149-.00259Zm-12.79835-1.59914h11.19867s-1.73372-9.59896-1.73372-9.59896l-7.73072-.00061-1.73369,9.59753-.00055,.00204Zm5.59923,23.99611l2.39961-14.39762-4.79898-.0005,2.39938,14.39812ZM15.27124,.00404L5.67177,.00045c-1.3252-.0254-2.42008,1.02829-2.44548,2.35349-.0254,1.3252,1.02829,2.42008,2.35349,2.44548,.03049,.00058,.061,.00059,.09149,0l9.60449,.00932c1.32406,.06055,2.44651-.96373,2.50706-2.28779,.06055-1.32406-.96373-2.44651-2.28779-2.50706-.07547-.00345-.15107-.00334-.22653,.00034l.00273-.01021Z",
    fill: "current"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPinned);
export default __webpack_public_path__ + "static/media/pinned.2de95031adba4a22a88a5d24e13bd941.svg";
export { ForwardRef as ReactComponent };